module.exports = __webpack_public_path__ + "static/media/Space_01.10fdaf4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lms/Space_01.jpg
// module id = 413
// module chunks = 0